// extracted by mini-css-extract-plugin
export default {"fb-header":"InviteFriendsHeader--fb-header--EzGjF","fbHeader":"InviteFriendsHeader--fb-header--EzGjF","headline":"InviteFriendsHeader--headline--E93dU"};